import { pathOr } from 'ramda';
import { FeeQuoteData, ID_TYPES } from './types';
import { SectionItem } from '../../app.models'

export function summarySectionConfig(
  state: FeeQuoteData,
  flow: string,
  labels: any,
  walletProvider: string = ''
) {
  let amountDetails;
  if (flow === 'deposit') {
    amountDetails = { ...pathOr('', ['transactions', 0, 'sendAmountDetails'], state) };
  } else {
    amountDetails = { ...pathOr('', ['transactions', 0, 'payoutAmountDetails'], state) };
  }
  let summarySections: SectionItem[] = [];

  const fees = {
    id_type: ID_TYPES.FEES,
    name: labels.stellar?.sdfcard?.common?.fees,
    value: convertByFXRate(state?.transactions, flow),
    sendCurrency: pathOr('USD', ['fees', 'currencyCode'], amountDetails),
    isBold: false,
    displayMinus: false,
  };

  let valPFee = undefined
  if (flow === "deposit"  && pathOr(undefined, ['transactions', 0, 'payoutAmountDetails', 'partnerFees', 'value'], state) && 
      pathOr(undefined, ['transactions', 0, 'sendAmountDetails', 'fxRate'], state) 
  ) {
    valPFee = (Number(pathOr(0, ['transactions', 0, 'payoutAmountDetails', 'partnerFees', 'value'], state))
             * Number(pathOr(0, ['transactions', 0, 'sendAmountDetails', 'fxRate'], state))).toFixed(2)
  }

  if (flow !== "deposit"  && pathOr(undefined, ['transactions', 0, 'sendAmountDetails', 'partnerFees', 'value'], state) && 
      pathOr(undefined, ['transactions', 0, 'payoutAmountDetails', 'fxRate'], state) 
  ) {
    valPFee = (Number(pathOr(0, ['transactions', 0, 'sendAmountDetails', 'partnerFees', 'value'], state))
    * Number(pathOr(0, ['transactions', 0, 'payoutAmountDetails', 'fxRate'], state))).toFixed(2)
  }

  const partnerWalletFee = labels.stellar?.sdfcard?.common?.partnerWalletFee;
  const walletLabel = partnerWalletFee ? partnerWalletFee : 'Wallet Fees';

   const partnerFees: SectionItem = {
    id_type: ID_TYPES.PARTNER_FEES,
    name: ((flow === 'deposit' && state?.cashInWalletFeeEnabled) || flow === 'withdraw' && state?.cashOutWalletFeeEnabled ) ? walletLabel.replace("%s1", walletProvider.charAt(0).toUpperCase() + walletProvider.slice(1).toLowerCase())  : labels.stellar?.sdfcard?.common?.fees,
    value: (String(Number(valPFee)) !== 'NaN')? Number(valPFee).toFixed(2) : '0.00',
    sendCurrency: flow === "deposit" ? pathOr('USD', ['transactions', 0, 'sendAmountDetails', 'totalAmount', 'currencyCode'], state) : pathOr('USD', ['transactions', 0, 'payoutAmountDetails', 'totalAmount', 'currencyCode'], state),
    isBold: false,
    displayMinus: false,
    supNumber: "2"
  };
  const taxes = {
    id_type: ID_TYPES.TAXES,
    name: labels.stellar?.sdfcard?.common?.taxes,
    value: pathOr(0, ['taxes', 'value'], amountDetails).toFixed(2),
    sendCurrency: pathOr('USD', ['taxes', 'currencyCode'], amountDetails),
    isBold: false,
    displayMinus: false,
  };
  const totalCost = {
    id_type: ID_TYPES.TOTAL_PAY_AMOUNT,
    name: (flow === 'deposit')? labels.stellar?.sdfcard?.common?.totalPayAmount : labels.stellar?.sdfcard?.common?.totalPickupAmount,
    value: pathOr(0, ['totalAmount', 'value'], amountDetails).toFixed(2),
    sendCurrency: pathOr('USD', ['totalAmount', 'currencyCode'], amountDetails),
    isBold: true,
    displayMinus: false,
  };
  
  if (flow === "deposit" || flow === 'withdraw') {
    summarySections.push(partnerFees);
  } else {
    summarySections.push(fees);
  } 
  summarySections.push(taxes);
  summarySections.push(totalCost);

  return summarySections;
}

function convertByFXRate(transactions: any, flow: any): any {
  // TODO:TIM fix types
  const value = pathOr(
    0,
    [0, 'sendAmountDetails', 'fees', 'value'],
    transactions
  );
  const fxRate = pathOr(0, [0, 'payoutAmountDetails', 'fxRate'], transactions);
  if (flow === 'withdraw') {
    return Number(value * fxRate).toFixed(2);
  }
  return Number(value).toFixed(2);
}

export function getFxRateFromQuote(feeQuote: FeeQuoteData, flow: string) {
  const trnData = pathOr(
    undefined,
    [
      'transactions',
      '0',
      flow === 'withdraw' ? 'payoutAmountDetails' : 'sendAmountDetails',
    ],
    feeQuote
  );
  return {
    fxRate:
      flow === 'deposit'
        ? feeQuote.transactions[0].sendAmountDetails.fxRate
        : feeQuote.transactions[0].payoutAmountDetails.fxRate,
    currency: trnData?.totalAmount?.currencyCode,
  };
}
